import {
  HANDLED_CHANGE,
  HANDLED_VALIDATED_FIELD,
  HANDLED_VALIDATED_FIELDS,
  SET_MESSAGE,
  FETCHED_CONTRACT,
  SAVED_CONTRACT,
  LAUNCHED_CONTRACT_TOGGLE,
  SENT_TOKENS,
  RESET_FORM,
} from './actionTypes';

// ContractForm
const handledChange = function handledChange(id, value) {
  return {
    type: HANDLED_CHANGE,
    id,
    value,
  };
};

const handledValidatedField = function handledValidatedField(id, value) {
  // HANDLED_VALIDATED_FIELD
  return {
    type: HANDLED_VALIDATED_FIELD,
    id,
    value,
  };
};

const handledValidatedFields = function handledValidatedFields(errors) {
  return {
    type: HANDLED_VALIDATED_FIELDS,
    value: errors,
  };
};

const setMessage = function setMessage(value) {
  return {
    type: SET_MESSAGE,
    value,
  };
};

// ContractShow
const fetchedContract = function fetchedContract(data) {
  return {
    type: FETCHED_CONTRACT,
    data,
  };
};

const savedContract = function savedContract(userInput) {
  return {
    type: SAVED_CONTRACT,
    userInput,
  };
};

const launchedContractToggle = function launchedContractToggle(tokenName) {
  //  it appears as tokenName here will be like {tokenName: "0"},
  //  where the 0 refers to the s.c tokenIndex, an index of where it is in is contractsarray?
  return {
    type: LAUNCHED_CONTRACT_TOGGLE,
    tokenName,
  };
};

const sentTokens = function sentTokens(id, tokens) {
  return {
    type: SENT_TOKENS,
    id,
    tokens,
  };
};

const resetForm = function resetForm() {
  return {
    type: RESET_FORM,
  };
};

export default {
  handledChange,
  handledValidatedField,
  handledValidatedFields,
  setMessage,
  fetchedContract,
  savedContract,
  launchedContractToggle,
  sentTokens,
  resetForm,
};



// WEBPACK FOOTER //
// ./src/actions.js